import React from 'react';
import { ModalContainer } from '@welbe/web-design-system';

interface ModalPdfProps {
	isOpen?: boolean;
	onClose?: () => void;
	url?: string;
}

export const ModalPdf = ({
	isOpen,
	onClose,
	url,
}: ModalPdfProps): JSX.Element => {
	return (
		<ModalContainer
			visible={isOpen}
			width="50vw"
			height="80vh"
			onClose={onClose}
		>
			<object data={url} type="application/pdf" width="100%" height="400%" />
		</ModalContainer>
	);
};
